import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './Hero.css';

const Hero = ({
  label,
  title,
  subtitle,
  description,
  primaryBtn,
  secondaryBtn,
  image,
  overlay = true,
  size = 'large',
}) => {
  return (
    <section
      className={`hero hero--${size}`}
      style={{ backgroundImage: image ? `url(${image})` : undefined }}
    >
      {overlay && <div className="hero__overlay" />}

      {/* Animated background elements */}
      <div className="hero__bg" aria-hidden="true">
        <div className="hero__tri hero__tri--1" />
        <div className="hero__tri hero__tri--2" />
        <div className="hero__tri hero__tri--3" />
        <div className="hero__tri hero__tri--4" />
        <div className="hero__tri hero__tri--5" />
        <div className="hero__orb hero__orb--1" />
        <div className="hero__orb hero__orb--2" />
        <div className="hero__grid-lines" />
        <svg className="hero__route" viewBox="0 0 1440 600" preserveAspectRatio="none">
          <path className="hero__route-path" d="M-20,400 C200,350 400,250 600,300 S900,200 1100,250 S1300,150 1460,200" fill="none" stroke="rgba(13,148,136,0.15)" strokeWidth="2" />
          <path className="hero__route-path hero__route-path--2" d="M-20,450 C250,400 450,300 650,350 S950,250 1150,300 S1350,200 1460,250" fill="none" stroke="rgba(13,148,136,0.08)" strokeWidth="1.5" />
          <circle className="hero__route-dot" r="4" fill="var(--teal-light)">
            <animateMotion dur="8s" repeatCount="indefinite" path="M-20,400 C200,350 400,250 600,300 S900,200 1100,250 S1300,150 1460,200" />
          </circle>
        </svg>
      </div>

      <div className="container hero__content">
        {label && <span className="hero__label">{label}</span>}
        <h1 className="hero__title">{title}</h1>
        {subtitle && <p className="hero__subtitle">{subtitle}</p>}
        {description && <p className="hero__description">{description}</p>}
        {(primaryBtn || secondaryBtn) && (
          <div className="hero__actions">
            {primaryBtn && (
              <Link to={primaryBtn.to} className="btn btn-primary btn-lg">
                {primaryBtn.text} <ArrowRight size={18} />
              </Link>
            )}
            {secondaryBtn && (
              <Link to={secondaryBtn.to} className="btn btn-secondary btn-lg">
                {secondaryBtn.text}
              </Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
